import { render, staticRenderFns } from "./logisticsDetails.vue?vue&type=template&id=784dcf40&scoped=true"
import script from "./logisticsDetails.vue?vue&type=script&lang=js"
export * from "./logisticsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784dcf40",
  null
  
)

export default component.exports